import { Clickable, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 152px;
  position: relative;

  @media (min-width: 1024px) {
    .mobile-heading {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    margin: 35px 0 0;

    h4 {
      letter-spacing: -0.5px;
      font-size: 30px;
      color: ${theme.SECONDARY};
      font-weight: 500;
      margin: 0 13px 35px;
    }
  }
`;

const BgsContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: -36px;

  @media (max-width: 1024px) {
    top: 52px;
  }
`;

const GreyBg = styled.div`
  height: 464px;
  width: 1280px;
  background-color: ${theme.GREY_10};
  align-self: center;

  @media (max-width: 1024px) {
    width: 100vw;
    height: 361px;
  }
`;

const GreenBg = styled.div`
  height: 183px;
  width: 100%;
  background-color: ${theme.GREEN};

  @media (max-width: 1024px) {
    width: 100vw;
    height: 102px;
  }
`;

const ContentContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

const ScrollContainer = styled.div`
  ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}
  padding-left: ${(props) => props.extraPad};
  display: flex;
  margin-top: 18px;

  @media (max-width: 1024px) {
    margin-top: 22px;
    padding-left: 17px;
    overflow-x: scroll;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 1140px;
  align-self: center;
  position: relative;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const Calculator = styled.div`
  margin-right: 160px;

  h4 {
    color: ${theme.SECONDARY};
    font-weight: 500;
    font-size: 30px;
    margin-bottom: 8px;
    letter-spacing: -0.5px;
  }

  p {
    font-size: 24px;
    margin-bottom: 26px;
    width: 279px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const AthleteFocusHeader = styled.div`
  h4 {
    font-size: 30px;
    font-weight: 500;
    color: ${theme.SECONDARY};
    letter-spacing: -0.5px;
  }

  h3 {
    font-size: 72px;
    line-height: 54px;
    margin-top: 16px;
    letter-spacing: -3.5px;
  }

  @media (max-width: 1024px) {
    .desktop-h3 {
      display: none;
    }

    .mobile-h3 {
      h3 {
        margin-top: 1px;
        font-size: 48px;
        line-height: 36.9px;
        letter-spacing: -1.5px;
        padding-left: 13px;
      }
    }

    h4 {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    .mobile-h3  {
      display: none;
    }
  }
`;

const CalculatorBox = styled.div`
  height: 330px;
  width: 400px;
  background-color: ${theme.SECONDARY};
  margin-right: 40px;

  img {
    width: 215px;
    margin: 15px 0 0 38px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const AthleteItem = styled.div`
  width: 330px;
  margin-top: px;
  margin-right: 40px;

  img {
    width: 330px;
    height: 330px;
    margin-bottom: 12px;
  }

  h5  {
    font-weight: 400;
    color: #fff;
    font-size: 24px;
  }

  p  {
    font-size: 24px;
  }

  @media (max-width: 1024px) {
    width: 240px;
    margin-right: 30px;

    img {
      width: 240px;
      height: 240px;
      margin-bottom: 3px;
    }

    h5  {
      font-weight: 400;
      color: #fff;
      font-size: 16px;
      margin-bottom: 3px;
    }

    p  {
      font-size: 16px;
    }
  }
`;

const ArrowsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 136px;
`;

const GoToAthleteZone = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 1140px;
  align-self: center;
  margin-top: 40px;

  p {
    font-size: 20px;
    letter-spacing: -0.35px;

    b {
      letter-spacing: -0.6px;
    }
  }

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 34px;
    margin-right: 13px;

    p {
      font-size: 16px;
    }
  }
`;

const AthleteFocus = (props) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    scrollRef = useRef(null),
    navigate = useNavigate();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2 - 9}px`);
  }

  return null;

  return (
    <Container>
      <Text h4 className="mobile-heading">
        {t('website.athleteFocus')}
      </Text>

      <ContentContainer>
        <HeaderRow>
          {/*
            <Calculator>
              <Text h4>{t("website.calculator")}</Text>
              <Text>{t("website.seeHowMuch")}</Text>
              <Icon type='arrowRightLonger' col={theme.SECONDARY} dimensions={40}/>
            </Calculator>
          */}

          <AthleteFocusHeader>
            <Text h4>{t('website.athleteFocus')}</Text>
            <Text h3 stencil className="desktop-h3">
              {' '}
              {t('website.weAllPlay')}
            </Text>

            <div className="mobile-h3">
              <Text h3 stencil>
                {t('website.weAll')}
              </Text>
              <Text h3 stencil>
                {t('website.playBetter')}
              </Text>
              <Text h3 stencil>
                {t('website.together')}
              </Text>
            </div>
          </AthleteFocusHeader>

          <ArrowsContainer>
            <div className="absolute-arrows">
              <Arrows elem={scrollRef} />
            </div>
          </ArrowsContainer>
        </HeaderRow>

        <ScrollContainer extraPad={extraPad} ref={scrollRef}>
          {/*/<div>
            <CalculatorBox>
              <img src={require('assets/images/calculator.png')} alt='' />
            </CalculatorBox>
          </div>*/}

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <div>
            <AthleteItem>
              <img src={require('assets/images/pogba.png')} alt="" />

              <Text h5>{t('website.video')}</Text>
              <Text>{t('website.tiffanyVan')}</Text>
            </AthleteItem>
          </div>
        </ScrollContainer>
      </ContentContainer>

      <BgsContainer>
        <GreyBg />
        <GreenBg />
      </BgsContainer>

      <GoToAthleteZone>
        <Clickable onClick={() => navigate('/athlete-zone')}>
          <Text>
            {t('website.goto')}
            <b> {t('website.athleteZoneSmall')}</b>
          </Text>
        </Clickable>
      </GoToAthleteZone>
    </Container>
  );
};

export default AthleteFocus;
